import articleTypes from "astrid-firestore/src/api/articles/constants/articleTypes";
import sortArtifactFiles from "astrid-firestore/src/api/artifacts/sortArtifactFiles";
import getCollectionData from "astrid-firestore/src/utils/getCollectionData";
import getDocumentData from "astrid-firestore/src/utils/getDocumentData";

async function fetchLinkedArticle(firebase, { article }) {
	if (article.type === articleTypes.EBOOK || !article.work?.ref) {
		return null;
	}

	const workEbookArticle = await getCollectionData(
		firebase
			.firestore()
			.collection("articles")
			.where("work.ref", "==", article.work.ref)
			.where("type", "==", articleTypes.EBOOK)
			.where("deleted", "==", false),
	);

	return (workEbookArticle.length > 0 && workEbookArticle[0]) || null;
}

export default async function constructPipelineDocument(firebase, document) {
	const articleRef = document.article?.ref;
	const channelRef = document.channel?.ref;
	const publisherRef = document.publisher?.ref;
	const artifactRef = document.artifact?.ref;

	const [channel, publisher, article] = await Promise.all([
		getDocumentData(channelRef),
		getDocumentData(publisherRef),
		getDocumentData(articleRef),
	]);

	const theArtifactRef = artifactRef || article?.artifact?.ref;

	const [artifact, files] = await Promise.all([
		getDocumentData(theArtifactRef),
		getCollectionData(theArtifactRef?.collection?.("files")),
	]);

	const linkedArticle = article && (await fetchLinkedArticle(firebase, { article }));

	return {
		channel: channel || null,
		publisher: publisher || null,
		article: article || document.article || null,
		artifact,
		files: artifact && files && sortArtifactFiles(files, artifact?.files),
		linkedArticle,
	};
}
